// extracted by mini-css-extract-plugin
module.exports = {"energySavingCTA":"EnergySavingCTA_energySavingCTA__R5Bqk","medal":"EnergySavingCTA_medal__OpfjA","alternativesNo":"EnergySavingCTA_alternativesNo__5YcjY"};